import React, { memo } from "react";

const FilterButtons = ({
  category = [],
  selectedCategory,
  setSelectedCategory,
}) => (
  <div className="flex mb-2 border-b pb-2 flex-wrap scrollbar-hide">
    {category.map((cat) => {
      const isActive = selectedCategory?.name === cat.name;
      return (
        <button
          key={cat.name}
          type="button"
          aria-pressed={isActive}
          className={`mr-4 mb-4 min-w-[120px] px-2 py-2 rounded-lg flex text-sm items-center justify-start gap-3 whitespace-nowrap font-medium transition-all duration-200
            ${
              isActive
                ? "bg-[#0457C2] text-white"
                : "bg-white text-[#0457C2] hover:bg-[#0457C2] hover:text-white"
            }
          `}
          onClick={() => setSelectedCategory(cat)}
          title={cat.name}
        >
          <span className="truncate">{cat.name}</span>
        </button>
      );
    })}
  </div>
);

export default memo(FilterButtons);
